export const NOT_FOUND = "/404";
// new line added
export const QuickNest_URL = "https://quicknest.in"
export const HOME_URL = "/";
export const TEAM_URL = "/team";
export const ABOUT_URL = "/about-us";
export const CONTACT_URL = "/contact-us";
export const SERVICES_URL = "/services";
export const DATABASE_MICRO_SERVICE_URL = "/services/database-micro-service-solutions";
export const STRATERGY_CONSULTING_SERVICE_URL = "/services/stratergy-and-consulting-service";
export const OFFSHORE_OUTSOURCING_SERVICE_URL = "/services/offshore-outsourcing-service";
export const DATABASE_MANAGEMENT_AND_OPTIMIZATION_SERVICE_URL = "/services/database-management-and-optimization";
export const DATABSE_MIGRATIONS_SERVICE_URL = "/services/database-migration-service";
export const CLOUD_MIGRATION_SERVICE_URL = "/services/cloud-migration-service";
export const DEVOPS_CONSULTING_SERVICE_URL = "/services/devops-consulting-service";
export const CI_CD_INTEGRATION_SERVICE_URL = "/services/ci-cd-integration-service";
export const DATA_ENGINEERING_SERVICE_URL = "/services/data-engineering-and-analytics";
export const CUSTOM_SOFTWARE_DEVELOPMENT_SERVICE_URL = "/services/custom-software-development-service";
export const WEB_DESIGN_AND_DEVELOPMENT_SERVICE_URL = "/services/web-design-and-development";
export const MOBILE_APP_DEVELOPMENT_SERVICE_URL = "/services/mobile-app-development";
